export const DESKTOP_BREAKPOINT = 992;
export const TABLET_BREAKPOINT = 720;
export const MOBILE_BREAKPOINT = 440;

export const BASE_URL = '/claim/card';

// Claim card routes
export const CLAIM_ROUTES = {
  GET_STARTED: `${BASE_URL}/get-started`,
  ADD_DETAILS: `${BASE_URL}/add-details`,
  CREATE_ACCOUNT: `${BASE_URL}/create-account`,
  GET_BLINQ: `${BASE_URL}/get-blinq`,
};

export const LS_CARD_CLAIM_FLOW_V2_FLAG_KEY = 'BLINQ_CARD_CLAIM_FLOW_V2';

export const steps = ['get-started', 'add-details', 'create-account', 'get-blinq'] as const;

export const claimFlowExperimentKeys = {
  experiment001: 'claim-flow-experiment-001',
};
